module.exports = __webpack_public_path__ + "zvetseni-prsou_41_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_41_before.jpg
// module id = 1336
// module chunks = 0